module.exports = __webpack_public_path__ + "assets/img/f9dcb07be7ef7629c66ad0f6bfefa64d.png";